import React from 'react';
import {observer} from 'mobx-react';
import {InputError, PanelTooltip, TimeInput} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import {types} from 'main/tools';
import moment from 'moment';
import _ from 'lodash';
import LocationIcon from './LocationIcon';

const EndTime = observer(({model, uiState}) => {
  const {errors} = uiState;

  if (model._type === types.HOLIDAY) {
    return null;
  }

  if (model._type === types.TIME_OFF.ABSENCE) {
    return <div>{model.timeRange}</div>;
  }

  if (uiState.cannotCreateOrEdit(model)) {
    return (
      <div className='flex align-items-middle justify-between'>
        <span>{model.endTimeString}</span>
        <LocationIcon clockEvent={model.clockOutEvent} uiState={uiState} />
      </div>
    );
  }

  return (
    <div className='flex align-items-middle justify-between'>
      <div className='relative'>
        <TimeInput
          key={model.uuid}
          className={uiState.endTimeChangedSinceApproval(model) && 'bg-caution'}
          initialValue={model.endTimeString}
          lowerBound={model.startTimeString}
          disabled={!!model.manuallyEnteredHours}
          onFormat={({value, error}) => (!error && value !== model.endTimeString) && uiState.updateEntry(model, {endTimeString: value})}
          style={uiState.endTimeChangedSinceApproval(model) ? {paddingRight: '1.5rem'} : {}}
        />
        {uiState.endTimeChangedSinceApproval(model) &&
          <div className='absolute' style={{lineHeight: 0, top: '11px', right: '8px'}}>
            <PanelTooltip>
              {model.approvedEndTime ?
                <div style={{lineHeight: 1}}>
                  <div className='pb2'>
                    <FormattedMessage id={'time_tracking.timesheet.EDITED_AFTER_APPROVAL'}/>
                  </div>
                  <div>
                    <FormattedMessage id={'time_tracking.timesheet.PREVIOUS_VALUE'}
                                      values={{time: <span className='bold'>{moment(model.approvedEndTime).utc().format(t('components.dates.TIMESTAMP_FORMAT'))}</span>}}/>
                  </div>
                </div> :
                <div style={{lineHeight: 1.42857143}}>
                  <FormattedMessage id={'time_tracking.timesheet.ADDED_AFTER_APPROVAL'}/>
                </div>
              }
            </PanelTooltip>
          </div>
        }
        <InputError style={{padding: 0}} message={_.get(errors, `entries.${model.id}.endTime`)}/>
      </div>
      <LocationIcon clockEvent={model.clockOutEvent} uiState={uiState} />
    </div>
  );
});

export default EndTime;
